import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserAPIModelsERoles } from 'user-ts-ng-client';

import { AuthService } from '@core/auth/auth.service';
import { UserDataService } from '@core/auth/user-data.service';

export const globalAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const userDataService = inject(UserDataService);
  const userRole = authService.getRole();

  if (userRole === UserAPIModelsERoles.GlobalAdmin) {
    return true;
  }

  if (userRole === UserAPIModelsERoles.OrganizationAdmin) {
    const organizationId = userDataService.getOrganizationId();
    void router.navigate(['/organization', organizationId]);
  }

  return false;
};
